<form class="flex flex-col" [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-form-field class="text-base" appearance="outline" subscriptSizing="dynamic">
    <mat-label class="text-base">{{ placeholder | transloco }}</mat-label>
    <input matInput autocomplete="off" formControlName="name" maxlength="50" />
    <mat-hint>{{ 'JOB_MANAGEMENT.HINT' | transloco }}</mat-hint>
  </mat-form-field>

  <div class="mt-5 flex gap-2 justify-end">
    <button mat-button mat-dialog-close class="h-10 w-22 text-primary">
      {{ 'JOB_MANAGEMENT.CANCEL_BUTTON' | transloco }}
    </button>
    <button
      mat-raised-button
      mat-dialog-close
      id="submit"
      type="submit"
      color="primary"
      class="h-10 w-22"
      [disabled]="disabledSubmitButton"
    >
      {{ buttonSubmit | transloco }}
    </button>
  </div>
</form>
